import DateRangePicker from "../../node_modules/flowbite-datepicker/js/DateRangePicker";
import DatePicker from "../../node_modules/flowbite-datepicker/js/DatePicker";
import ptBR from "../../node_modules/flowbite-datepicker/js/i18n/locales/pt-BR.js";

DatePicker.locales['pt-BR'] = ptBR['pt-BR'];

const options = {
    language: "pt-BR",
    format: "dd/mm/yyyy",
    autohide: true,
    clearBtn: true,
    todayBtn: true,
    todayBtnMode: 1,
    todayHighlight: true,
    // buttonClass: "text-gray-700 dark:text-gray-100 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-600 focus:ring-0 text-xs py-1 leading-4"
}

const elementsRange = document.querySelectorAll('[data-daterangepicker]');

elementsRange.forEach(element => {
    new DateRangePicker(element, { ...options, allowOneSidedRange: true });
});

const elements = document.querySelectorAll('[data-datepicker]');

elements.forEach(element => {
    new DatePicker(element, options);
});
